import React, { Fragment, useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import DueDate from "./components/DueDate/DueDate";
import SummaryGrid from "./components/SummaryGrid/SummaryGrid";
import useQueryParams, { COUNTRY_PARAM } from "../../hooks/useQueryParams";
import useClient from "../../hooks/useClient";
import {getISOSubmitDateString} from "../../pages/utils/date.utils";

type Status = {
  FW: boolean;
  EQ: boolean;
  AP: boolean;
  TB: boolean;
};

type ShipmentStatus = {
  NMP: Status;
  NSP: Status;
  "Nike Store Owned": Status;
  "Nike Store Hybrid": Status;
  "Nike Value Store": Status;
  "Nike.com": Status;
  "3PP Consignment": Status;
  "3PP Drop Ship": Status;
};

type ServerResponse = {
  [key: string]: ShipmentStatus;
};

interface ShipmentSummaryProps {
  submitDate: Date
}
const ShipmentSummary = (props: ShipmentSummaryProps) => {
  const submitDate: string = getISOSubmitDateString(props.submitDate);
  const { queryParams } = useQueryParams();
  const countries = queryParams.get(COUNTRY_PARAM);
  const { fetchWithAuth } = useClient();
  const [shipmentStatuses, setShipmentStatuses] = useState<{
    [key: string]: ShipmentStatus;
  }>({});
  useEffect(() => {
    if (countries?.length) {
      const callTaskStatus = async () => {
        const URI = `/v1/landing/forecast/task-status?currForecast=${submitDate}&country=${countries}`;
        const data = await fetchWithAuth<ServerResponse>(
          URI,
          (text: string) => console.warn(text),
        );
        return data;
      };
      callTaskStatus().then((data) => {
        const dataWithoutDueDate: { [key: string]: ShipmentStatus } =
          Object.entries(data).reduce((acc, [key, value]) => {
            return { ...acc, [key]: value };
          }, {});
        setShipmentStatuses(dataWithoutDueDate);
      });
    }
  }, [countries]);
  return (
    <>
      <Typography variant="h3" marginTop="100px">
        Shipment Submit Summary
      </Typography>
      <DueDate />
      {Object.keys(shipmentStatuses).length
        ? queryParams
            .get(COUNTRY_PARAM)
            ?.split(",")
            .filter((param) => shipmentStatuses[param] !== undefined)
            .map((param) => (
              <Fragment key={param}>
                <Typography variant="h4" margin="15px 20px 20px">
                  {param
                    .split(" ")
                    .map(
                      (splitParam) =>
                        `${splitParam
                          .substring(0, 1)
                          .toUpperCase()}${splitParam.substring(1)}`,
                    )
                    .join(" ")}
                </Typography>
                <SummaryGrid
                  incomingStatuses={shipmentStatuses[decodeURI(param)]}
                  country={param}
                />
              </Fragment>
            ))
        : null}
    </>
  );
};

export default ShipmentSummary;
